var _rect, _text, _text2, _text3, _rect2, _rect3, _text4, _line, _path, _rect4, _text5, _rect5, _text6, _text7, _line2, _path2, _rect6, _text8, _line3, _text9, _text10, _text11, _text12, _rect7, _rect8, _text13, _line4, _path3, _rect9, _text14, _text15, _text16, _line5, _path4, _rect10, _text17, _text18, _text19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase5Fig4DeployOrdering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 470",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 470,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Deploy ordering, before and after D-022")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "The failure class lived in the gap between new code serving and the schema catching up.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 126,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#DC2626"
  }, "BEFORE")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 140,
    width: 500,
    height: 270,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E5DED2",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 168,
    width: 180,
    height: 44,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#1A2F2A",
    strokeWidth: 1.2
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 194,
    fontSize: 12.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "merge to main")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 272,
    y1: 190,
    x2: 330,
    y2: 190,
    stroke: "#4A5F56",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330 190 l-7 -4 v8 z",
    fill: "#4A5F56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 168,
    width: 192,
    height: 44,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#1A2F2A",
    strokeWidth: 1.2
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 432,
    y: 194,
    fontSize: 12.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "new code serves")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 304,
    width: 180,
    height: 44,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 323,
    fontSize: 12,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "schema push waits")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 339,
    fontSize: 12,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "on a human")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 272,
    y1: 326,
    x2: 330,
    y2: 326,
    stroke: "#7C3AED",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M330 326 l-7 -4 v8 z",
    fill: "#7C3AED"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 304,
    width: 192,
    height: 44,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#1A2F2A",
    strokeWidth: 1.2
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 432,
    y: 330,
    fontSize: 12.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "schema updated, later")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 432,
    y1: 212,
    x2: 432,
    y2: 304,
    stroke: "#DC2626",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 248,
    fontSize: 12,
    fontWeight: 600,
    fill: "#DC2626"
  }, "the window:")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 265,
    fontSize: 12,
    fill: "#DC2626"
  }, "new code, old schema,")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 282,
    fontSize: 12,
    fill: "#DC2626"
  }, "500s live here")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 126,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#16A34A"
  }, "AFTER D-022")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 636,
    y: 140,
    width: 504,
    height: 270,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 668,
    y: 168,
    width: 150,
    height: 44,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#1A2F2A",
    strokeWidth: 1.2
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 743,
    y: 194,
    fontSize: 12.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "merge to main")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 818,
    y1: 190,
    x2: 866,
    y2: 190,
    stroke: "#4A5F56",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M866 190 l-7 -4 v8 z",
    fill: "#4A5F56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 872,
    y: 160,
    width: 236,
    height: 88,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.5
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 990,
    y: 184,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "the build applies schema")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 990,
    y: 202,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "and catalog first")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 990,
    y: 226,
    fontSize: 11.5,
    fill: "#16A34A",
    textAnchor: "middle",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "fails closed without its credential")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 990,
    y1: 248,
    x2: 990,
    y2: 296,
    stroke: "#4A5F56",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M990 296 l-4 -7 h8 z",
    fill: "#4A5F56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 872,
    y: 302,
    width: 236,
    height: 44,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#1A2F2A",
    strokeWidth: 1.2
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 990,
    y: 328,
    fontSize: 12.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "new code serves")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 316,
    fontSize: 12,
    fill: "#4A5F56"
  }, "no window: the code that serves")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 333,
    fontSize: 12,
    fill: "#4A5F56"
  }, "never runs ahead of its schema")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase5Fig4DeployOrdering);
export default __webpack_public_path__ + "static/media/case5-fig4-deploy-ordering.59dbf5ce3ec498e7483d104cfa5943c2.svg";
export { ForwardRef as ReactComponent };